import { render, staticRenderFns } from "./ChamadoNovo.vue?vue&type=template&id=2bb7b95e"
import script from "./ChamadoNovo.vue?vue&type=script&lang=js"
export * from "./ChamadoNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports